export const FONT =
  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export const T = {
  canvas: "#080808",
  ink: "#f8fafc",
  muted: "#94a3b8",
  hair: "rgba(255, 255, 255, 0.08)",
  arrow: "rgba(139, 92, 246, 0.7)",
  chip: "rgba(255, 255, 255, 0.06)",
  purple: { fill: "rgba(139, 92, 246, 0.14)", line: "#8b5cf6", text: "#c4b5fd" },
  indigo: { fill: "rgba(99, 102, 241, 0.14)", line: "#818cf8", text: "#a5b4fc" },
  slate: { fill: "rgba(255, 255, 255, 0.035)", line: "rgba(255, 255, 255, 0.12)", text: "#cbd5e1" },
  green: { fill: "rgba(16, 185, 129, 0.12)", line: "#34d399", text: "#6ee7b7" },
  cyan: { fill: "rgba(6, 182, 212, 0.14)", line: "#22d3ee", text: "#67e8f9" },
  amber: { fill: "rgba(245, 158, 11, 0.12)", line: "#fbbf24", text: "#fcd34d" },
};
